import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimExcludeContractObjectFromWorkOrderMutation } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimExcludeContractObjectFromWorkOrderGql } from '../../bimWorkOrderQueries';

import { useResetWorkOrderFiltersWithStructureOps } from './useOnSuccessStructureOps';

const requestId = 'bimExcludeContractObjectFromWorkOrder';

export const useBimExcludeContractObjectToWorkOrder = (workOrderId?: number) => {
    const dispatch = useDispatch();

    const { makeResetWorkOrderObjectFilter } = useResetWorkOrderFiltersWithStructureOps();

    const onSuccessWithWorkOrderObjReset = useCallback(
        ({ payload }: { payload: BimExcludeContractObjectFromWorkOrderMutation }) => {
            makeResetWorkOrderObjectFilter(payload?.bimExcludeContractObjectFromWorkOrder?.data);
        },
        [makeResetWorkOrderObjectFilter],
    );

    const [
        bimExcludeContractObjectFromWorkOrderData,
        bimExcludeContractObjectFromWorkOrderStatus,
        bimExcludeContractObjectFromWorkOrderError,
        bimExcludeContractObjectFromWorkOrderRequest,
    ] = useRequest({
        requestId,
        query: bimExcludeContractObjectFromWorkOrderGql,
        withEffect: false,
        dependenciesUpdater: onSuccessWithWorkOrderObjReset,
    });

    const [bimExcludeContractObjectFromWorkOrderReset] = useResetStoreData({ requestId });

    const bimExcludeContractObjectFromWorkOrderMakeRequest = useCallback(
        (contractObjectId: number) => {
            dispatch(bimExcludeContractObjectFromWorkOrderRequest({ contractObjectId, workOrderId }));
        },
        [bimExcludeContractObjectFromWorkOrderRequest, dispatch, workOrderId],
    );

    return {
        bimExcludeContractObjectFromWorkOrderReset,
        bimExcludeContractObjectFromWorkOrderData,
        bimExcludeContractObjectFromWorkOrderStatus,
        bimExcludeContractObjectFromWorkOrderError,
        bimExcludeContractObjectFromWorkOrderMakeRequest,
    };
};
